import { render, staticRenderFns } from "./guideVip.vue?vue&type=template&id=496d73fc&scoped=true&"
import script from "./guideVip.vue?vue&type=script&lang=ts&"
export * from "./guideVip.vue?vue&type=script&lang=ts&"
import style0 from "./guideVip.vue?vue&type=style&index=0&id=496d73fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496d73fc",
  null
  
)

export default component.exports